module.exports = __webpack_public_path__ + "media/assets/images/ncino-watermark-0c3eedeb447f40f46dbd3a3138461147.png";